import moment from "moment";
import React, { useEffect, useState } from "react";
import { AiFillEye, AiOutlineDownload } from "react-icons/ai";
import { useSelector } from "react-redux";
import { useDispatch } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
import {
  getClaimComments,
  getSingleClaim,
  resetClaimStatus,
} from "../../../../redux/slice/claim/claimSlice";
import { LoaderTwo } from "../../../../components/loader/LoaderTwo";
import { dejoinBy_, handleDownload } from "../../../../utils/helpers/functions";
import PageTitle from "../../../../components/partials/PageTitle";
import ModalContainer from "../../../../components/modals/ModalContainer";
import ClaimComment from "../../../../components/modals/claims/ClaimComment";

const dynamicFields = (dynamic_values) => {
  const objectData = {};
  if (dynamic_values) {
    for (const element of dynamic_values) {
      objectData[element.field_name] = element.value;
    }
    return objectData;
  }
};

const PolicySingleClaimHistoryView = () => {
  const { single_claim, isSuccess, isUpdated, claim_comments } = useSelector(
    (state) => state.claim
  );
  const {
    policyHolder,
    policy_cover,
    claim_process_settings,
    createSuccess,
    tempCoverInfo,
  } = useSelector((state) => state.claim);
  const { user_role, user_permissions } = useSelector(
    (state) => state?.auth?.user
  );
  const { all_covers } = useSelector((state) => state.cover);

  //   local state variables
  const [hasEditClaim, setHasEditClaim] = useState(null);
  const [commentItem, setCommentItem] = useState(false);
  const [editClaim, setEditClaim] = useState(false);
  const fileTypes = ["JPG", "PNG", "PDF", "DOC", "DOCX"];
  const [isUploading, setIsUploading] = useState(false);
  const [selectedFile, setSelectedFile] = useState("");
  const [detailsOfLoss, setDetailsOfLoss] = useState(
    single_claim?.single_claim_process_details?.details_of_loss
  );
  const [fileList, setFileList] = useState([]);
  const [policyCover, setPolicyCover] = useState("");
  const [disable, setDisable] = useState(null);

  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { state } = useLocation();

  const breadcrumb = {
    from: {
      title: "Claim History",
      link: "",
    },
    current: {
      title: "Claim Process",
      link: null,
    },
  };

  useEffect(() => {
    setDetailsOfLoss(
      single_claim?.single_claim_process_details?.details_of_loss
    );
    setFileList(
      single_claim?.single_claim_process_details?.documents &&
        JSON.parse(single_claim?.single_claim_process_details?.documents)
    );
  }, [single_claim]);

  useEffect(() => {
    // get single claim on page load or reload
    if (!isUpdated) {
      dispatch(getSingleClaim(state?.id));
    }

    if (isUpdated) {
      dispatch(resetClaimStatus());
      navigate("/admin/claims/all-claims");
    }
  }, [isUpdated]);

  useEffect(() => {
    dispatch(
      getClaimComments({
        claim_uuid: single_claim?.single_claim_process_details?.id,
        claim_id: single_claim?.single_claim_process_details?.claim_id,
      })
    );
  }, [
    dispatch,
    single_claim?.single_claim_process_details?.claim_id,
    single_claim?.single_claim_process_details?.id,
  ]);

  useEffect(() => {
    if (
      !user_permissions?.some(
        (permission) => permission.name === "claim module"
      ) ||
      !user_permissions?.some((permission) => permission.name === "view claim")
    ) {
      navigate("/admin/dashboard");
    }

    setHasEditClaim(
      user_permissions?.some((permission) => permission.name === "edit claim")
    );
  }, [navigate, user_permissions]);

  if (!single_claim) {
    return (
      <div className='mt-2'>
        <LoaderTwo />
      </div>
    );
  }

  return (
    <div>
      {/* page title */}
      <PageTitle title='View Claim' breadcrumb={breadcrumb} back />
      {/* end page title */}
      <div className='row'>
        <div className='col-md-12'>
          <div className='card p-3'>
            <div>
              <h4 className='text-primary'>Policy Information</h4>
              <div className='row'>
                <div className='col-md-12 col-lg-10'>
                  <div className='row'>
                    <div className='col-md-6 mt-1 '>
                      <span className='fw-bold me-2'>Customer Name: </span>
                      <span>
                        {single_claim?.single_claim_process_details
                          ?.customerFirstName +
                          " " +
                          single_claim?.single_claim_process_details
                            ?.customerLastName}
                      </span>
                    </div>
                    <div className='col-md-6 mt-2'>
                      <span className='fw-bold me-2'>Customer Id: </span>
                      <span>
                        {single_claim?.single_claim_process_details?.customerId}
                      </span>
                    </div>
                    <div className='col-md-6 mt-2'>
                      <span className='fw-bold me-2'>Marketer/Agent: </span>
                      <span>
                        {single_claim?.single_claim_process_details
                          ?.agentFirstName +
                          single_claim?.single_claim_process_details
                            ?.agentLastName}
                      </span>
                    </div>
                    <div className='col-md-6 mt-2 '>
                      <span className='fw-bold me-2'>Policy No: </span>
                      <span>
                        {
                          single_claim?.single_claim_process_details
                            ?.policyAppNumber
                        }
                      </span>
                    </div>
                    <div className='col-md-6 mt-2'>
                      <span className='fw-bold me-2'>Policy Name: </span>
                      <span>
                        {single_claim?.single_claim_process_details?.policyName}
                      </span>
                      {/* <span>{policyHolder?.policyName}</span> */}
                    </div>
                    <div className='col-md-6 mt-2'>
                      <span className='fw-bold me-2'>Status: </span>
                      {single_claim?.single_claim_process_details?.status ? (
                        <>
                          <span className='badge badge-success-lighten'>
                            {single_claim?.single_claim_process_details
                              ?.status === "2" && "Active"}
                          </span>
                          <span className='badge badge-warning-lighten'>
                            {single_claim?.single_claim_process_details
                              ?.status === "1" && "Pending"}
                          </span>
                          <span className='badge badge-danger-lighten'>
                            {single_claim?.single_claim_process_details
                              ?.status === "3" && "Matured"}
                          </span>
                          <span className='badge badge-danger-lighten'>
                            {policyHolder?.status === "4" && "Claim Processed"}
                          </span>
                        </>
                      ) : null}
                    </div>
                    <div className='col-md-6 mt-2'>
                      <span className='fw-bold me-2'>Duration: </span>
                      <span>
                        {single_claim?.single_claim_process_details?.duration
                          ? single_claim?.single_claim_process_details
                              ?.duration + "months"
                          : null}
                      </span>
                    </div>
                    <div className='col-md-6 mt-2'>
                      <span className='fw-bold me-2'>Discount: </span>
                      <span>
                        {single_claim?.single_claim_process_details?.discount
                          ? single_claim?.single_claim_process_details
                              ?.discount + "%"
                          : "Nil"}
                      </span>
                    </div>
                    <div className='col-md-6 mt-2'>
                      <span className='fw-bold me-2'>End Date: </span>
                      <span>
                        {moment(
                          single_claim?.single_claim_process_details?.endDate
                        ).format("LL")}
                      </span>
                    </div>
                    <div className='col-md-6 mt-2'>
                      <span className='fw-bold me-2'>Effective Date: </span>
                      <span>
                        {moment(
                          single_claim?.single_claim_process_details
                            ?.effectiveDate
                        ).format("LL")}
                      </span>
                    </div>
                    <div className='col-md-6 mt-2'>
                      <span className='fw-bold me-2'>Total Premium: </span>
                      <span>
                        &#8358;
                        {
                          single_claim?.single_claim_process_details
                            ?.totalPremium
                        }
                      </span>
                    </div>
                    <div className='col-md-6 mt-2'>
                      <span className='fw-bold me-2'>But-Charge: </span>
                      {single_claim?.single_claim_process_details?.butCharge ? (
                        <span>
                          &#8358;{" "}
                          {
                            single_claim?.single_claim_process_details
                              ?.butCharge
                          }
                        </span>
                      ) : (
                        "Nil"
                      )}
                    </div>
                    <div className='col-md-6 mt-2'>
                      <span className='fw-bold me-2'>Renewal Date: </span>
                      <span>
                        {moment(
                          single_claim?.single_claim_process_details?.endDate
                        ).format("LL")}
                      </span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className='pt-3'>
              <h4 className='text-primary'>Claims Information</h4>
              <div className='row'>
                <div className='col-md-4'>
                  <label htmlFor='firstName ' className='fw-bold pb-1'>
                    Claim Number
                  </label>
                  <p className='text-capitalize'>
                    {single_claim?.single_claim_process_details?.claim_id}
                  </p>
                </div>
                <div className='col-md-4'>
                  <label htmlFor='firstName ' className='fw-bold pb-1'>
                    Policy Cover
                  </label>
                  <p className='text-capitalize'>
                    {
                      all_covers?.unpaginated_cover?.filter(
                        (cover) =>
                          String(
                            single_claim?.single_claim_process_details
                              ?.policy_cover
                          ) === String(cover.id)
                      )[0]?.name
                    }
                  </p>
                </div>
                <div className='col-md-4'></div>
              </div>
              <div className='row mt-2'>
                <div className='col-md-4'>
                  <label htmlFor='firstName ' className='fw-bold pb-1'>
                    Claim Amount
                  </label>
                  <p className='form-control border-0 shadow'>
                    {single_claim?.single_claim_process_details?.claim_amount}
                  </p>
                </div>
                <div className='col-md-4'>
                  <label htmlFor='firstName ' className='fw-bold pb-1'>
                    Total Premium Paid
                  </label>
                  <p className='form-control border-0 shadow'>
                    {
                      single_claim?.single_claim_process_details
                        ?.total_premium_paid
                    }
                  </p>
                </div>
                <div className='col-md-4'>
                  <label htmlFor='firstName ' className='fw-bold pb-1'>
                    Last Premium Paid Date
                  </label>

                  <p className='form-control border-0 shadow'>
                    {moment(
                      single_claim?.single_claim_process_details
                        ?.premium_paid_date
                    ).format("D-MM-YYYY")}
                  </p>
                </div>
                <div className='col-md-4'>
                  <label htmlFor='firstName ' className='fw-bold pb-1'>
                    Reason for Claim
                  </label>

                  <p className='form-control border-0 shadow'>
                    {
                      single_claim?.single_claim_process_details
                        ?.reason_for_claim
                    }
                  </p>
                </div>
                <div className='col-md-4'>
                  <label htmlFor='firstName ' className='fw-bold pb-1'>
                    Date of Loss
                  </label>

                  <p className='form-control border-0 shadow'>
                    {single_claim?.single_claim_process_details?.date_of_loss}
                  </p>
                </div>
                <div className='col-md-12'>
                  <label htmlFor='firstName ' className='fw-bold pb-1 mt-2'>
                    Details of Loss
                  </label>
                  <div className='form-control border-0 shadow py-2 px-2'>
                    <div
                      dangerouslySetInnerHTML={{
                        __html:
                          single_claim?.single_claim_process_details
                            ?.details_of_loss,
                      }}
                    />
                  </div>
                </div>
              </div>
            </div>
            <div className=''>
              {!editClaim && (
                <>
                  <h4 className='pt-3 text-primary'>Documents</h4>
                  <div>
                    {fileList?.length &&
                      fileList?.map((item, index) => (
                        <div
                          key={index + "document"}
                          className='d-flex justify-content-between align-items-center form-control shadow border-0'
                        >
                          <span>
                            {index + 1}. Document-{index + 1}
                          </span>
                          <div className='d-flex align-items-center gap-2 text-primary'>
                            <span
                              onClick={() => handleDownload(item, index + 1)}
                              className='cursor-p'
                            >
                              <AiOutlineDownload size={20} />
                            </span>
                            <a href={item} target='_blank'>
                              <AiFillEye size={20} />
                            </a>
                          </div>
                        </div>
                      ))}
                  </div>
                </>
              )}
            </div>
            <div className='pt-3'>
              <h4 className='text-primary'>Custom Form Information</h4>
              <div className='row'>
                {single_claim?.single_claim_process_details &&
                  JSON.parse(
                    single_claim?.single_claim_process_details?.dynamic_fields
                  )?.map((customForm, index) => {
                    return (
                      <div className='mb-3 col-sm-9 col-md-7' key={index}>
                        {/* For inputs that are not checkbox or file or button */}
                        {customForm?.field_type !== "checkbox" &&
                        customForm?.field_type !== "file" &&
                        customForm?.field_type !== "button" ? (
                          <div>
                            <label
                              htmlFor='firstName '
                              className='fw-bold pb-1'
                            >
                              {dejoinBy_(customForm?.field_name)}
                            </label>

                            <>
                              <p className='form-control border-0 shadow'>
                                {customForm?.value}
                              </p>
                            </>
                          </div>
                        ) : null}

                        {/* For checkbox input */}
                        {customForm?.field_type === "checkbox" && (
                          <div>
                            <div class='form-check'>
                              <input
                                class={`form-check-input`}
                                type='checkbox'
                                checked={customForm?.value[0]}
                              />

                              <label
                                className='form-check-label fw-bold'
                                htmlFor='flexCheckDefault'
                                style={{ marginTop: "2px" }}
                              >
                                {dejoinBy_(customForm?.field_name)}
                              </label>

                              {customForm?.compulsory_field === 1 && (
                                <span className='text-danger ms-1'>*</span>
                              )}
                            </div>
                          </div>
                        )}
                        {/* For file inputs */}
                        {customForm?.field_type === "file" ? (
                          <div>
                            <label htmlFor='' className='fw-bold pb-1 me-1'>
                              {dejoinBy_(customForm?.field_name)}
                            </label>
                            {customForm?.value &&
                              selectedFile === customForm?.field_name &&
                              !isUploading && (
                                <span>
                                  <i className='mdi mdi-check'></i>
                                </span>
                              )}
                            <>
                              <div className='d-flex justify-content-between align-items-center form-control shadow border-0'>
                                <span>
                                  Download/View {customForm?.field_name}
                                </span>
                                <div className='d-flex align-items-center gap-2 text-primary'>
                                  <span
                                    onClick={() =>
                                      handleDownload(
                                        customForm?.value,
                                        customForm?.field_name
                                      )
                                    }
                                    className='cursor-p'
                                  >
                                    <AiOutlineDownload size={20} />
                                  </span>
                                  <a href={customForm?.value} target='_blank'>
                                    <AiFillEye size={20} />
                                  </a>
                                </div>
                              </div>
                            </>
                          </div>
                        ) : null}
                      </div>
                    );
                  })}
              </div>
            </div>
            <div className=''>
              {claim_comments?.length > 0 && (
                <>
                  <h4 className='pt-3 text-primary'>Comments</h4>
                  <div>
                    {claim_comments?.map((item, index) => (
                      <div
                        key={index}
                        className='d-flex justify-content-between align-items-center form-control shadow border-0 mb-2 w-50'
                      >
                        <span>{item.user_role}</span>
                        <div
                          className='text-primary cursor-p'
                          onClick={() => {
                            setCommentItem(item);
                          }}
                          data-bs-toggle='modal'
                          data-bs-target='#comment_view'
                        >
                          <span>
                            <AiFillEye size={20} />
                          </span>
                        </div>
                      </div>
                    ))}
                  </div>
                </>
              )}
            </div>
          </div>
        </div>
      </div>
      <ModalContainer
        modal_id='comment_view'
        modal_width='modal-md'
        bradius='rounded-2'
      >
        <ClaimComment data={commentItem || []} />
      </ModalContainer>
    </div>
  );
};

export default PolicySingleClaimHistoryView;
